export default {
  getAPIError(error) {
    return error;
  },
};
